import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context";
import { storeHelpers } from "../storeApi";

const PriceOrLogin = ({ price, className = "", strikethroughPrice, sqftPrice }) => {
  const { currentUser, openAuthModal } = useContext(AppContext) || {};
  const navigate = useNavigate();
  const isTempGuestUser =
    Boolean(currentUser?.temp === true) ||
    String(currentUser?.mobile ?? "")
      .toLowerCase()
      .startsWith("guest_");
  const isLoggedIn =
    Boolean(currentUser && (currentUser.id || currentUser.user_id) && currentUser.mobile) &&
    !isTempGuestUser;

  if (!isLoggedIn) {
    return (
      <button
        type="button"
        className={`btn btn-link p-0 text-primary text-decoration-none ${className}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof openAuthModal === "function") {
            openAuthModal();
            return;
          }
          navigate("/register");
        }}
      >
        Login to view Price
      </button>
    );
  }

  const priceUnavailable = (price == null || price === 0) && (sqftPrice == null || sqftPrice === 0);
  if (priceUnavailable) return <span className={`text-muted ${className}`}>₹N/A</span>;
  const displayPrice = price ?? sqftPrice;
  return (
    <span className={`d-inline-flex flex-column ${className}`}>
      {strikethroughPrice != null && Number(strikethroughPrice) !== Number(displayPrice) && (
        <span className="text-muted text-decoration-line-through">
          MRP {storeHelpers.formatPrice(Number(strikethroughPrice))}
        </span>
      )}
      <span className="d-inline-flex align-items-baseline gap-1">
        {price != null && price !== 0 && (
          <span className="mb-0 fw-bold text-dark">
            {storeHelpers.formatPrice(Number(price))}
          </span>
        )}
        {(price != null && price !== 0) || (sqftPrice != null && sqftPrice !== 0) ? (
          <small className="text-muted fw-normal">incl. GST</small>
        ) : null}
        {sqftPrice != null && sqftPrice !== 0 && (
          <span className="small text-primary">
            ({storeHelpers.formatSqftPrice(Number(sqftPrice))})
          </span>
        )}
      </span>
    </span>
  );
};

export default PriceOrLogin;
